import Recent from './Recent';

export default Recent;
